<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/bilibili/channel"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="https://www.bilibili.com/v/channel/3240712?tab=multiple" target="_blank">杨超越频道</a>
      &nbsp;&nbsp;
      <a href="https://space.bilibili.com/630836232" target="_blank">杨超越主页</a>
    </div>
    <div class="ui hidden divider"></div>
    <div class="row">
      <date-picker range valueType="format" @clear="range=[]" v-model="range"></date-picker>
      <button class="ui load button" @click="load">Load</button>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
.ui.load.button {
  margin-left: 12px;
}
</style>
<script>
  import Vuetable from '../../table/Vuetable.vue'
  import VuetablePagination from '../../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'BilibiliChannel',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'date', title: '日期', sortField: 'date'},
          {name: 'view', title: '播放量', callback: 'count'},
          {name: 'archive', title: '视频数量', callback: 'count'},
          {name: 'subscribed', title: '订阅数量'},
          {name: 'featured', title: '精选视频数'},
        ],
        page: 0,
        range: [],
        options: null,
        sortOrder: [
          {
            field: 'date',
            direction: 'desc'
          }
        ]
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.range = [];
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      count(value) {
        if (value >= 1e8) {
          return (value / 1e8).toFixed(1) + '亿'
        } else if (value >= 1e4) {
          return (value / 1e4).toFixed(1) + '万'
        } else {
          return value + ''
        }
      },
      load: function () {
        let api = `/bilibili/channel/chart?size=10&page=${this.page}`
        if (this.range.length === 2) {
          api = `/bilibili/channel/chart?start=${this.range[0]}&end=${this.range[1]}`
        }
        axios.get(api).then(response => {
          this.options =
              {
                title: {
                  text: '增幅'
                },
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['播放量', '视频数量', '订阅数量', '精选视频数']
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                  {
                    name: '播放量',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.view])
                  },
                  {
                    name: '视频数量',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.archive])
                  },
                  {
                    name: '订阅数量',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.subscribed])
                  },
                  {
                    name: '精选视频数',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.featured])
                  },
                ]
              };
        });
      }
    }
  }
</script>
